import React, { Component } from 'react';
import { translate } from 'react-i18next';
import { Icon } from 'react-icons-kit';
import { arrowCircleRight } from 'react-icons-kit/fa/arrowCircleRight';

import Button from 'components/Button/Button';

import './Matter.css';

class Matter extends Component {

  goSearch = () => {
    const { type } = this.props;
    const url = `${window.location.href.split('/catalogocartoteca/')[0]}/catalogocartoteca/search/${type}`;
    window.location.href = url;
  }

  render() {
    const { title, image, number } = this.props;
    return (
      <div className='matterContainer'>
        <img src={image} alt={`Imagen - ${title}`} />
        <p>{title}</p>
        <hr/>
        <div className='matterBtnContainer'>
          <Button text={'Consultar'} active={true} number={number} onClick={this.goSearch}>
            <span>&nbsp;&nbsp;&nbsp;<Icon size={'16px'} icon={arrowCircleRight} /></span>
          </Button>
        </div>
      </div>
    );
  }
}

export default translate()(Matter);
